import { produce } from "immer";
import ACTIONS from "../actions/types.actions";

const unitVacancy = produce((draft, action) => {
  switch (action.type) {
    case ACTIONS.UNIT_VACANCY_REQUEST:
      draft[action.key] = true;
      return draft;
    case ACTIONS.UNIT_VACANCY_SUCCESS:
      draft.loading = false;
      draft.error = null;
      draft.value = action.response;
      return draft;
    case ACTIONS.UNIT_VACANCY_SUGGESTION_SUCCESS:
      draft.suggestionLoading = false;
      draft.error = null;
      return draft;
    case ACTIONS.UNIT_VACANCY_TAGS_SUCCESS:
      draft.tags = action.response;
      return draft;
    case ACTIONS.UPCOMING_VACANT_PROPERTIES_TAG_SUCCESS:
      draft.upcomingVacantPropertyTags = action.response;
      return draft;
    case ACTIONS.UNIT_VACANCY_LIST_SUCCESS:
      draft.loading = false;
      draft.error = null;
      draft.list = action.response.list;
      draft.pagination = action.response.pagination;
      return draft;
    case ACTIONS.UPCOMING_VACANT_PROPERTY_LIST_SUCCESS:
      draft.loading = false;
      draft.error = null;
      draft.list = action.response.list;
      draft.upcomingVacantPagination = action.response.pagination;
      return draft;
    case ACTIONS.UNIT_VACANCY_ERROR:
      draft[action.key] = false;
      draft.error = action.error;
      return draft;
    default:
      return draft;
  }
});

export default unitVacancy;
